import React from 'react'
import NetworkError from '@/pages/NetworkError'
import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

// 闪送学堂
export default [
  {
    path: '/courierView/NetworkError', // 网络错误页
    component: props => <NetworkError {...props} />
  },
  {
    path: '/courierView/home', // 学堂首页
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/home/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/categroy', // 二级分类页
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/categroy/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/detail', // 培训详情页
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/detail/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/trainingTest', // 课程考试
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/trainingTest/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/testSuccess', // 考试通过
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/testSuccess/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/testError', // 考试失败
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/testError/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/studyPicture', // 图片学习
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyPicture/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/studyVideo', // 视频学习
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyVideo/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/errorProblem', // 错题集
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/errorProblem/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/alreadyStudy', // 学习完成
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/alreadyStudy/main'),
      loading: LoadingComponent
    })
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyTask', // 学习任务
    exact: true
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/citySelect/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyTask/citySelect' // 学习任务
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/appointmentSelect/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyTask/appointmentSelect' // 学习任务
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/detail/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyTaskDetail' // 学习任务
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/wait/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyTaskWait' // 学习任务
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/waitTrain/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyTaskWaitTrain' // 学习任务
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/reschedule/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyTaskReschedule' // 学习任务
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyTask/scheduleSuccess/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyScheduleSuccess' // 学习任务
  },
  {
    path: '/courierView/shansongStudy/studyRecord', // 学习记录
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyRecord/index'),
      loading: LoadingComponent
    })
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyRecord/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyRecord' // 学习记录
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studySearch/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studySearch' // 学习搜索
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongStudy/studyLimitTask/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongStudy/studyLimitTask' // 接单限制时学习任务列表
  }
]
